export function mergeOrder<T>(
  stored: readonly T[] | undefined,
  defaults: readonly T[],
): T[] {
  return Array.from(new Set([...(stored ?? []), ...defaults]));
}

export function reorderArray<T>(
  stored: readonly T[] | undefined,
  defaults: readonly T[],
  dragIndex: number,
  hoverIndex: number,
): T[] {
  const order = mergeOrder(stored, defaults);
  const [item] = order.splice(dragIndex, 1);
  order.splice(hoverIndex, 0, item);
  return order;
}

export function reorderNumeric(
  items: readonly { id: string }[],
  dragIndex: number,
  hoverIndex: number,
  step = 10,
): Record<string, number> {
  const entries = items.map((c, i) => ({ id: c.id, order: i * step }));
  entries[dragIndex].order =
    entries[hoverIndex].order + (dragIndex < hoverIndex ? 1 : -1);
  entries.sort((a, b) => a.order - b.order);
  return Object.fromEntries(entries.map((e, i) => [e.id, i]));
}
